(function () {
  const PRICE_MAP_SELECTOR = 'script[data-collection-price-map]';
  const GRID_PRODUCT_SELECTOR = 'product-grid-item[data-product-handle]';
  const GLOBO_CARD_SELECTOR = '.spf-product-card';
  const GLOBO_PRICE_SELECTOR = '.spf-product-card__price.money';

  const state = (window.awCollectionPriceFallback =
    window.awCollectionPriceFallback || {
      observer: null,
      priceMap: {},
      productPriceRequests: {}
    });
  const TAX_SUFFIX = '(税込)';

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const splitDisplayPrice = (displayPrice) => {
    const text = String(displayPrice || '').trim();
    if (!text) return { amount: '', full: '' };

    if (text.endsWith(TAX_SUFFIX)) {
      return {
        amount: text.slice(0, -TAX_SUFFIX.length),
        full: text
      };
    }

    return { amount: text, full: text };
  };

  const buildGridPriceMarkup = (displayPrice) => {
    const { amount, full } = splitDisplayPrice(displayPrice);
    if (!full) return '';

    return (
      '<span aria-hidden="true"><span class="list_price_item">' +
      escapeHtml(amount) +
      '</span><small class="tax_in">' +
      escapeHtml(TAX_SUFFIX) +
      '</small></span><span class="visually-hidden">' +
      escapeHtml(full) +
      '</span>'
    );
  };

  const buildGloboPriceMarkup = (displayPrice) => {
    const { amount, full } = splitDisplayPrice(displayPrice);
    if (!full) return '';

    return (
      '<span class="list_price_item">' +
      escapeHtml(amount) +
      '</span><small class="tax_in">' +
      escapeHtml(TAX_SUFFIX) +
      '</small>'
    );
  };

  const parsePriceMaps = (root = document) => {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(PRICE_MAP_SELECTOR).forEach((script) => {
      try {
        const map = JSON.parse(script.textContent || '{}');
        if (!map || typeof map !== 'object') return;

        Object.keys(map).forEach((handle) => {
          state.priceMap[handle] = map[handle];
        });
      } catch (error) {
        console.warn('aw-collection-price-fallback: invalid price map', error);
      }
    });
  };

  const getVisibleText = (node) => (node ? node.textContent.trim() : '');
  const hasPriceValue = (text) => /[0-9¥￥]/.test(text || '');
  const shouldReplacePrice = (text) => !hasPriceValue((text || '').replace(/\s+/g, ''));

  const formatPriceFromCents = (cents) => {
    const numericCents = Number(cents);
    if (!Number.isFinite(numericCents)) return '';

    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(numericCents / 100);
  };

  const buildDisplayPriceFromProductJson = (product) => {
    if (!product || typeof product !== 'object') return '';

    const hasVariedPrice =
      Boolean(product.price_varies) ||
      (Number(product.price_min) > 0 &&
        Number(product.price_max) > 0 &&
        Number(product.price_min) !== Number(product.price_max));

    const basePrice = hasVariedPrice
      ? Number(product.price_min || product.price || 0)
      : Number(product.price || product.price_min || 0);
    const formattedPrice = formatPriceFromCents(basePrice);

    if (!formattedPrice) return '';

    return formattedPrice + (hasVariedPrice ? '～' + TAX_SUFFIX : TAX_SUFFIX);
  };

  const fetchDisplayPriceForHandle = (handle) => {
    if (!handle) return Promise.resolve('');

    if (state.priceMap[handle]) {
      return Promise.resolve(state.priceMap[handle]);
    }

    if (state.productPriceRequests[handle]) {
      return state.productPriceRequests[handle];
    }

    state.productPriceRequests[handle] = fetch(
      '/products/' + encodeURIComponent(handle) + '.js',
      { credentials: 'same-origin' }
    )
      .then((response) => (response.ok ? response.json() : null))
      .then((product) => {
        const displayPrice = buildDisplayPriceFromProductJson(product);

        if (displayPrice) {
          state.priceMap[handle] = displayPrice;
        }

        return displayPrice;
      })
      .catch(() => '')
      .finally(() => {
        delete state.productPriceRequests[handle];
      });

    return state.productPriceRequests[handle];
  };

  const fillGridProductPrices = (root = document) => {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(GRID_PRODUCT_SELECTOR).forEach((productCard) => {
      const handle = productCard.dataset.productHandle;
      const displayPrice = state.priceMap[handle];

      if (!handle || !displayPrice) return;

      const currentPrice = productCard.querySelector('.grid-product__price--current');
      if (!currentPrice) return;
      if (!shouldReplacePrice(getVisibleText(currentPrice))) return;

      currentPrice.innerHTML = buildGridPriceMarkup(displayPrice);
    });

    root.querySelectorAll(GRID_PRODUCT_SELECTOR).forEach((productCard) => {
      const handle = productCard.dataset.productHandle;
      const currentPrice = productCard.querySelector('.grid-product__price--current');

      if (!handle || !currentPrice) return;
      if (!shouldReplacePrice(getVisibleText(currentPrice))) return;
      if (state.priceMap[handle]) return;

      fetchDisplayPriceForHandle(handle).then((displayPrice) => {
        if (!displayPrice) return;
        if (!productCard.isConnected) return;

        const latestPrice = productCard.querySelector('.grid-product__price--current');
        if (!latestPrice) return;
        if (!shouldReplacePrice(getVisibleText(latestPrice))) return;

        latestPrice.innerHTML = buildGridPriceMarkup(displayPrice);
      });
    });
  };

  const getHandleFromHref = (href) => {
    if (!href) return '';

    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  };

  const fillGloboPrices = (root = document) => {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(GLOBO_CARD_SELECTOR).forEach((card) => {
      const priceNode = card.querySelector(GLOBO_PRICE_SELECTOR);
      if (!priceNode) return;

      const href =
        card.querySelector('.spf-product-card__image-wrapper[href]')?.getAttribute('href') ||
        card.querySelector('.spf-product-card__title a[href]')?.getAttribute('href');
      const handle = getHandleFromHref(href);
      const displayPrice = state.priceMap[handle];

      if (!handle || !displayPrice) return;

      priceNode.innerHTML = buildGloboPriceMarkup(displayPrice);
    });
  };

  const applyPrices = (root = document) => {
    parsePriceMaps(document);
    fillGridProductPrices(root);
    fillGloboPrices(root);
  };

  const observe = () => {
    const observeRoot =
      document.querySelector('#CollectionAjaxContent') ||
      document.querySelector('#gf-grid') ||
      document.body;

    if (!observeRoot) return;

    if (state.observer) {
      state.observer.disconnect();
    }

    state.observer = new MutationObserver((mutations) => {
      let shouldApply = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (
            node.matches?.(GRID_PRODUCT_SELECTOR) ||
            node.matches?.(GLOBO_CARD_SELECTOR) ||
            node.matches?.(PRICE_MAP_SELECTOR) ||
            node.querySelector?.(GRID_PRODUCT_SELECTOR) ||
            node.querySelector?.(GLOBO_CARD_SELECTOR) ||
            node.querySelector?.(PRICE_MAP_SELECTOR)
          ) {
            shouldApply = true;
          }
        });
      });

      if (shouldApply) {
        window.requestAnimationFrame(() => applyPrices(document));
      }
    });

    state.observer.observe(observeRoot, {
      childList: true,
      subtree: true
    });
  };

  const init = () => {
    applyPrices(document);
    observe();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('page:loaded', init);
})();
